import { render, staticRenderFns } from "./ModelShow.vue?vue&type=template&id=cec53d04&scoped=true&"
import script from "./ModelShow.vue?vue&type=script&lang=js&"
export * from "./ModelShow.vue?vue&type=script&lang=js&"
import style0 from "./ModelShow.vue?vue&type=style&index=0&id=cec53d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec53d04",
  null
  
)

export default component.exports